// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.App-header {
  background-color: #2c3e50;
  padding: 20px;
  color: white;
}

.App-header h1 {
  margin: 0 0 15px 0;
  font-size: 2em;
}

.nav-tabs {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.nav-tabs button {
  background-color: transparent;
  color: white;
  border: 2px solid white;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 5px;
  font-size: 1em;
  transition: all 0.3s;
}

.nav-tabs button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.nav-tabs button.active {
  background-color: white;
  color: #2c3e50;
}

.partner-filter {
  padding: 8px 16px;
  border: 2px solid white;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  font-size: 0.95em;
  cursor: pointer;
  margin-left: 20px;
}

.partner-filter:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.partner-filter option {
  background-color: #2c3e50;
  color: white;
}

.map-container {
  margin: 20px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.loading {
  padding: 100px;
  font-size: 1.2em;
  color: #666;
}

.stats {
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 20px;
  flex-wrap: wrap;
}

.stat-card {
  background: white;
  padding: 20px 40px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  min-width: 120px;
}

.stat-card h3 {
  margin: 0;
  font-size: 2.5em;
  color: #3498db;
}

.stat-card p {
  margin: 5px 0 0 0;
  color: #666;
  font-size: 0.9em;
}

.dashboard {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.dashboard-summary {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 20px;
}

.dashboard-section {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.dashboard-section h2 {
  margin: 0 0 15px 0;
  color: #2c3e50;
  font-size: 1.3em;
  border-bottom: 2px solid #3498db;
  padding-bottom: 10px;
}

.dashboard-section h3 {
  margin: 15px 0 10px 0;
  color: #34495e;
  font-size: 1.1em;
}

.list-container {
  max-height: 400px;
  overflow-y: auto;
}

.list-item {
  background: #f8f9fa;
  padding: 12px;
  margin-bottom: 10px;
  border-radius: 5px;
  border-left: 4px solid #3498db;
  text-align: left;
}

.list-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.signal-type, .opp-type, .task-type, .deal-name {
  font-weight: bold;
  color: #2c3e50;
  text-transform: capitalize;
}

.confidence, .score, .priority, .deal-value {
  font-weight: bold;
  padding: 3px 8px;
  border-radius: 3px;
  background: #ecf0f1;
}

.description {
  margin: 8px 0;
  color: #555;
  font-size: 0.9em;
}

.meta {
  display: flex;
  gap: 15px;
  font-size: 0.85em;
  color: #7f8c8d;
  margin-top: 8px;
}

.status, .stage {
  background: #e8f4f8;
  padding: 2px 8px;
  border-radius: 3px;
  text-transform: capitalize;
}

.deals-summary {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  flex-wrap: wrap;
}

.deal-stage {
  background: #ecf0f1;
  padding: 15px;
  border-radius: 5px;
  flex: 1 1;
  min-width: 100px;
  text-align: center;
}

.deal-stage h4 {
  margin: 0 0 5px 0;
  color: #2c3e50;
  font-size: 0.9em;
  text-transform: capitalize;
}

.deal-stage p {
  margin: 3px 0;
  color: #555;
  font-size: 0.85em;
}

.deal-stage .deal-value {
  font-weight: bold;
  color: #27ae60;
  font-size: 1.1em;
}

.partner-tag {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 0.75em;
  font-weight: bold;
  margin-left: 8px;
  color: white;
}

.partner-tag.BossAqua {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.partner-tag.FFF {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.partner-tag.Aller-Aqua {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.partner-tag.General {
  background: linear-gradient(135deg, #95a5a6 0%, #7f8c8d 100%);
}

.country-tag {
  display: inline-flex;
  align-items: center;
  background: #ecf0f1;
  color: #2c3e50;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 0.75em;
  margin-left: 8px;
}

.location-edit-panel {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid #ecf0f1;
}

.location-edit-panel.tight {
  padding-top: 6px;
}

.location-input-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 8px;
  margin: 10px 0;
}

.location-input {
  padding: 6px 8px;
  border: 1px solid #dcdde1;
  border-radius: 6px;
  font-size: 0.85em;
}

.deal-detail-panel {
  background: #fff;
  border: 1px solid #ecf0f1;
  border-radius: 10px;
  padding: 16px;
  margin: 20px 0;
  box-shadow: 0 6px 18px rgba(0,0,0,0.08);
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.detail-header h3 {
  margin: 0;
}

.close-btn {
  background: transparent;
  border: none;
  font-size: 1.2em;
  cursor: pointer;
  color: #7f8c8d;
}

.detail-summary p {
  margin: 4px 0;
  color: #2c3e50;
}

.detail-metrics {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 10px 0;
}

.metric-badge {
  background: #ecf0f1;
  color: #34495e;
  border-radius: 20px;
  padding: 4px 10px;
  font-size: 0.85em;
}

.metric-badge.warning {
  background: #fdebd0;
  color: #d35400;
}

.metric-badge.neutral {
  background: #edf2ff;
  color: #2d4b8c;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  margin-top: 12px;
}

.detail-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.detail-actions .secondary-btn {
  font-size: 0.85em;
  padding: 6px 12px;
}

.detail-column {
  border: 1px solid #ecf0f1;
  border-radius: 8px;
  padding: 12px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.detail-column h4 {
  margin-top: 0;
  margin-bottom: 8px;
  color: #34495e;
}

.detail-section {
  margin-top: 16px;
}

.detail-section h4 {
  margin-bottom: 8px;
}

.detail-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.detail-list li {
  border: 1px solid #ecf0f1;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 8px;
  background: #fafafa;
}

.detail-list li span {
  display: block;
  font-size: 0.8em;
  color: #7f8c8d;
}

.detail-list li p {
  margin: 6px 0 0 0;
  color: #2c3e50;
}

.settings-section .keyword-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
  margin-bottom: 12px;
}

.settings-section .keyword-card {
  border: 1px solid #ecf0f1;
  border-radius: 8px;
  padding: 10px;
  background: #fff;
  box-shadow: 0 4px 10px rgba(0,0,0,0.05);
}

.settings-section .keyword-card strong {
  display: block;
  margin-bottom: 6px;
  text-transform: capitalize;
}

.detail-link {
  margin-top: 6px;
  padding: 4px 8px;
  border: 1px solid #3498db;
  border-radius: 6px;
  background: #3498db;
  color: #fff;
  cursor: pointer;
  font-size: 0.8em;
}

.detail-link:hover {
  background: #2980b9;
}

.empty-text {
  color: #7f8c8d;
  font-style: italic;
}

.error-text {
  color: #e74c3c;
}

.unmapped-deals {
  margin-top: 20px;
  padding: 16px;
  border: 1px solid #ecf0f1;
  border-radius: 10px;
  background: #fff;
}

.unmapped-list .unmapped-item {
  margin-bottom: 10px;
}

.unmapped-item .reason {
  color: #7f8c8d;
  font-style: italic;
}

.source-link {
  color: #3498db;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}

.source-link:hover {
  color: #2980b9;
  text-decoration: underline;
}

.empty-state {
  padding: 40px 20px;
  text-align: center;
  color: #7f8c8d;
}

.empty-state p {
  margin-bottom: 15px;
  font-size: 0.95em;
}

.empty-state code {
  display: block;
  background: #ecf0f1;
  padding: 10px;
  border-radius: 4px;
  font-size: 0.85em;
  color: #2c3e50;
  overflow-x: auto;
}

.data-quality-section {
  grid-column: 1 / -1;
}

.quality-summary {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  justify-content: space-around;
}

.quality-stat {
  background: #f8f9fa;
  padding: 15px 25px;
  border-radius: 8px;
  text-align: center;
  flex: 1 1;
  min-width: 120px;
  border: 2px solid #e9ecef;
}

.quality-count {
  display: block;
  font-size: 2em;
  font-weight: bold;
  color: #e74c3c;
  margin-bottom: 5px;
}

.quality-label {
  display: block;
  font-size: 0.85em;
  color: #6c757d;
}

.quality-item {
  border-left-width: 5px;
}

.quality-item.priority-high {
  border-left-color: #e74c3c;
  background: #fff5f5;
}

.quality-item.priority-medium {
  border-left-color: #f39c12;
  background: #fffbf5;
}

.quality-item.priority-low {
  border-left-color: #95a5a6;
  background: #f8f9fa;
}

.quality-entity {
  font-weight: bold;
  color: #2c3e50;
}

.priority-badge {
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.75em;
  font-weight: bold;
  text-transform: uppercase;
}

.highlight-card {
  border: 2px solid #e74c3c;
}

.highlight-card h3 {
  color: #e74c3c;
}

.attention-section {
  grid-column: 1 / -1;
}

.attention-section h2 {
  border-bottom-color: #e74c3c;
}

.section-subtitle {
  margin: -10px 0 15px 0;
  font-size: 0.85em;
  color: #7f8c8d;
  text-align: left;
}

.attention-item {
  border-left-color: #e74c3c;
  background: #fff5f5;
}

.news-search-status {
  padding: 10px 15px;
  border-radius: 6px;
  margin-bottom: 12px;
  font-size: 0.9em;
  text-align: left;
}

.news-search-status.searching {
  background: #eef6ff;
  color: #2980b9;
  animation: pulse 1.5s ease-in-out infinite;
}

.news-search-status.done {
  background: #eefff5;
  color: #27ae60;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
}

.inline-edit {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 10px;
  padding: 8px;
  background: white;
  border-radius: 6px;
  border: 1px solid #ddd;
}

.edit-input {
  flex: 1 1;
  padding: 8px 12px;
  border: 2px solid #3498db;
  border-radius: 5px;
  font-size: 0.9em;
  outline: none;
}

.edit-input:focus {
  border-color: #2980b9;
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.15);
}

.save-btn {
  padding: 8px 14px;
  background: #27ae60;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.85em;
  white-space: nowrap;
}

.save-btn:hover:not(:disabled) {
  background: #219a52;
}

.save-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.cancel-btn {
  padding: 8px 10px;
  background: #ecf0f1;
  color: #7f8c8d;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.9em;
}

.secondary-btn {
  margin-top: 10px;
  padding: 8px 14px;
  border-radius: 6px;
  border: 1px solid #2980b9;
  background: #fff;
  color: #2980b9;
  cursor: pointer;
  font-size: 0.9em;
}

.secondary-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.cancel-btn:hover {
  background: #ddd;
}

.fix-btn {
  padding: 4px 10px;
  background: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8em;
  margin-left: auto;
}

.fix-btn:hover {
  background: #2980b9;
}

.complete-btn {
  padding: 4px 10px;
  background: #27ae60;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8em;
  margin-left: auto;
}

.complete-btn:hover {
  background: #219a52;
}

.task-create-form {
  flex-wrap: wrap;
}

.priority-select {
  padding: 8px;
  border: 2px solid #ddd;
  border-radius: 5px;
  font-size: 0.85em;
  background: white;
}

.date-input {
  padding: 7px;
  border: 2px solid #ddd;
  border-radius: 5px;
  font-size: 0.85em;
}

.section-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #3498db;
  padding-bottom: 10px;
  margin-bottom: 15px;
}

.section-header-row h2 {
  margin: 0;
  border-bottom: none;
  padding-bottom: 0;
}

.scan-btn {
  padding: 6px 14px;
  background: #3498db;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.85em;
  white-space: nowrap;
}

.scan-btn:hover:not(:disabled) {
  background: #2980b9;
}

.scan-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,SAAO;EACP,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".App {\n  text-align: center;\n  min-height: 100vh;\n  background-color: #f5f5f5;\n}\n\n.App-header {\n  background-color: #2c3e50;\n  padding: 20px;\n  color: white;\n}\n\n.App-header h1 {\n  margin: 0 0 15px 0;\n  font-size: 2em;\n}\n\n.nav-tabs {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n}\n\n.nav-tabs button {\n  background-color: transparent;\n  color: white;\n  border: 2px solid white;\n  padding: 10px 20px;\n  cursor: pointer;\n  border-radius: 5px;\n  font-size: 1em;\n  transition: all 0.3s;\n}\n\n.nav-tabs button:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.nav-tabs button.active {\n  background-color: white;\n  color: #2c3e50;\n}\n\n.partner-filter {\n  padding: 8px 16px;\n  border: 2px solid white;\n  border-radius: 5px;\n  background-color: rgba(255, 255, 255, 0.1);\n  color: white;\n  font-size: 0.95em;\n  cursor: pointer;\n  margin-left: 20px;\n}\n\n.partner-filter:hover {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.partner-filter option {\n  background-color: #2c3e50;\n  color: white;\n}\n\n.map-container {\n  margin: 20px;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n.loading {\n  padding: 100px;\n  font-size: 1.2em;\n  color: #666;\n}\n\n.stats {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  padding: 20px;\n  flex-wrap: wrap;\n}\n\n.stat-card {\n  background: white;\n  padding: 20px 40px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  min-width: 120px;\n}\n\n.stat-card h3 {\n  margin: 0;\n  font-size: 2.5em;\n  color: #3498db;\n}\n\n.stat-card p {\n  margin: 5px 0 0 0;\n  color: #666;\n  font-size: 0.9em;\n}\n\n.dashboard {\n  padding: 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.dashboard-summary {\n  display: flex;\n  justify-content: center;\n  gap: 15px;\n  margin-bottom: 30px;\n  flex-wrap: wrap;\n}\n\n.dashboard-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 20px;\n}\n\n.dashboard-section {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n.dashboard-section h2 {\n  margin: 0 0 15px 0;\n  color: #2c3e50;\n  font-size: 1.3em;\n  border-bottom: 2px solid #3498db;\n  padding-bottom: 10px;\n}\n\n.dashboard-section h3 {\n  margin: 15px 0 10px 0;\n  color: #34495e;\n  font-size: 1.1em;\n}\n\n.list-container {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.list-item {\n  background: #f8f9fa;\n  padding: 12px;\n  margin-bottom: 10px;\n  border-radius: 5px;\n  border-left: 4px solid #3498db;\n  text-align: left;\n}\n\n.list-item-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.signal-type, .opp-type, .task-type, .deal-name {\n  font-weight: bold;\n  color: #2c3e50;\n  text-transform: capitalize;\n}\n\n.confidence, .score, .priority, .deal-value {\n  font-weight: bold;\n  padding: 3px 8px;\n  border-radius: 3px;\n  background: #ecf0f1;\n}\n\n.description {\n  margin: 8px 0;\n  color: #555;\n  font-size: 0.9em;\n}\n\n.meta {\n  display: flex;\n  gap: 15px;\n  font-size: 0.85em;\n  color: #7f8c8d;\n  margin-top: 8px;\n}\n\n.status, .stage {\n  background: #e8f4f8;\n  padding: 2px 8px;\n  border-radius: 3px;\n  text-transform: capitalize;\n}\n\n.deals-summary {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 15px;\n  flex-wrap: wrap;\n}\n\n.deal-stage {\n  background: #ecf0f1;\n  padding: 15px;\n  border-radius: 5px;\n  flex: 1;\n  min-width: 100px;\n  text-align: center;\n}\n\n.deal-stage h4 {\n  margin: 0 0 5px 0;\n  color: #2c3e50;\n  font-size: 0.9em;\n  text-transform: capitalize;\n}\n\n.deal-stage p {\n  margin: 3px 0;\n  color: #555;\n  font-size: 0.85em;\n}\n\n.deal-stage .deal-value {\n  font-weight: bold;\n  color: #27ae60;\n  font-size: 1.1em;\n}\n\n.partner-tag {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-size: 0.75em;\n  font-weight: bold;\n  margin-left: 8px;\n  color: white;\n}\n\n.partner-tag.BossAqua {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.partner-tag.FFF {\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n}\n\n.partner-tag.Aller-Aqua {\n  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);\n}\n\n.partner-tag.General {\n  background: linear-gradient(135deg, #95a5a6 0%, #7f8c8d 100%);\n}\n\n.country-tag {\n  display: inline-flex;\n  align-items: center;\n  background: #ecf0f1;\n  color: #2c3e50;\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 0.75em;\n  margin-left: 8px;\n}\n\n.location-edit-panel {\n  margin-top: 12px;\n  padding-top: 10px;\n  border-top: 1px solid #ecf0f1;\n}\n\n.location-edit-panel.tight {\n  padding-top: 6px;\n}\n\n.location-input-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 8px;\n  margin: 10px 0;\n}\n\n.location-input {\n  padding: 6px 8px;\n  border: 1px solid #dcdde1;\n  border-radius: 6px;\n  font-size: 0.85em;\n}\n\n.deal-detail-panel {\n  background: #fff;\n  border: 1px solid #ecf0f1;\n  border-radius: 10px;\n  padding: 16px;\n  margin: 20px 0;\n  box-shadow: 0 6px 18px rgba(0,0,0,0.08);\n}\n\n.detail-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.detail-header h3 {\n  margin: 0;\n}\n\n.close-btn {\n  background: transparent;\n  border: none;\n  font-size: 1.2em;\n  cursor: pointer;\n  color: #7f8c8d;\n}\n\n.detail-summary p {\n  margin: 4px 0;\n  color: #2c3e50;\n}\n\n.detail-metrics {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 10px 0;\n}\n\n.metric-badge {\n  background: #ecf0f1;\n  color: #34495e;\n  border-radius: 20px;\n  padding: 4px 10px;\n  font-size: 0.85em;\n}\n\n.metric-badge.warning {\n  background: #fdebd0;\n  color: #d35400;\n}\n\n.metric-badge.neutral {\n  background: #edf2ff;\n  color: #2d4b8c;\n}\n\n.detail-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 16px;\n  margin-top: 12px;\n}\n\n.detail-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-bottom: 12px;\n}\n\n.detail-actions .secondary-btn {\n  font-size: 0.85em;\n  padding: 6px 12px;\n}\n\n.detail-column {\n  border: 1px solid #ecf0f1;\n  border-radius: 8px;\n  padding: 12px;\n  background: #fff;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.detail-column h4 {\n  margin-top: 0;\n  margin-bottom: 8px;\n  color: #34495e;\n}\n\n.detail-section {\n  margin-top: 16px;\n}\n\n.detail-section h4 {\n  margin-bottom: 8px;\n}\n\n.detail-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.detail-list li {\n  border: 1px solid #ecf0f1;\n  border-radius: 8px;\n  padding: 10px;\n  margin-bottom: 8px;\n  background: #fafafa;\n}\n\n.detail-list li span {\n  display: block;\n  font-size: 0.8em;\n  color: #7f8c8d;\n}\n\n.detail-list li p {\n  margin: 6px 0 0 0;\n  color: #2c3e50;\n}\n\n.settings-section .keyword-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.settings-section .keyword-card {\n  border: 1px solid #ecf0f1;\n  border-radius: 8px;\n  padding: 10px;\n  background: #fff;\n  box-shadow: 0 4px 10px rgba(0,0,0,0.05);\n}\n\n.settings-section .keyword-card strong {\n  display: block;\n  margin-bottom: 6px;\n  text-transform: capitalize;\n}\n\n.detail-link {\n  margin-top: 6px;\n  padding: 4px 8px;\n  border: 1px solid #3498db;\n  border-radius: 6px;\n  background: #3498db;\n  color: #fff;\n  cursor: pointer;\n  font-size: 0.8em;\n}\n\n.detail-link:hover {\n  background: #2980b9;\n}\n\n.empty-text {\n  color: #7f8c8d;\n  font-style: italic;\n}\n\n.error-text {\n  color: #e74c3c;\n}\n\n.unmapped-deals {\n  margin-top: 20px;\n  padding: 16px;\n  border: 1px solid #ecf0f1;\n  border-radius: 10px;\n  background: #fff;\n}\n\n.unmapped-list .unmapped-item {\n  margin-bottom: 10px;\n}\n\n.unmapped-item .reason {\n  color: #7f8c8d;\n  font-style: italic;\n}\n\n.source-link {\n  color: #3498db;\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.2s;\n}\n\n.source-link:hover {\n  color: #2980b9;\n  text-decoration: underline;\n}\n\n.empty-state {\n  padding: 40px 20px;\n  text-align: center;\n  color: #7f8c8d;\n}\n\n.empty-state p {\n  margin-bottom: 15px;\n  font-size: 0.95em;\n}\n\n.empty-state code {\n  display: block;\n  background: #ecf0f1;\n  padding: 10px;\n  border-radius: 4px;\n  font-size: 0.85em;\n  color: #2c3e50;\n  overflow-x: auto;\n}\n\n.data-quality-section {\n  grid-column: 1 / -1;\n}\n\n.quality-summary {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  justify-content: space-around;\n}\n\n.quality-stat {\n  background: #f8f9fa;\n  padding: 15px 25px;\n  border-radius: 8px;\n  text-align: center;\n  flex: 1;\n  min-width: 120px;\n  border: 2px solid #e9ecef;\n}\n\n.quality-count {\n  display: block;\n  font-size: 2em;\n  font-weight: bold;\n  color: #e74c3c;\n  margin-bottom: 5px;\n}\n\n.quality-label {\n  display: block;\n  font-size: 0.85em;\n  color: #6c757d;\n}\n\n.quality-item {\n  border-left-width: 5px;\n}\n\n.quality-item.priority-high {\n  border-left-color: #e74c3c;\n  background: #fff5f5;\n}\n\n.quality-item.priority-medium {\n  border-left-color: #f39c12;\n  background: #fffbf5;\n}\n\n.quality-item.priority-low {\n  border-left-color: #95a5a6;\n  background: #f8f9fa;\n}\n\n.quality-entity {\n  font-weight: bold;\n  color: #2c3e50;\n}\n\n.priority-badge {\n  color: white;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 0.75em;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.highlight-card {\n  border: 2px solid #e74c3c;\n}\n\n.highlight-card h3 {\n  color: #e74c3c;\n}\n\n.attention-section {\n  grid-column: 1 / -1;\n}\n\n.attention-section h2 {\n  border-bottom-color: #e74c3c;\n}\n\n.section-subtitle {\n  margin: -10px 0 15px 0;\n  font-size: 0.85em;\n  color: #7f8c8d;\n  text-align: left;\n}\n\n.attention-item {\n  border-left-color: #e74c3c;\n  background: #fff5f5;\n}\n\n.news-search-status {\n  padding: 10px 15px;\n  border-radius: 6px;\n  margin-bottom: 12px;\n  font-size: 0.9em;\n  text-align: left;\n}\n\n.news-search-status.searching {\n  background: #eef6ff;\n  color: #2980b9;\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n.news-search-status.done {\n  background: #eefff5;\n  color: #27ae60;\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.6; }\n}\n\n.inline-edit {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  margin-top: 10px;\n  padding: 8px;\n  background: white;\n  border-radius: 6px;\n  border: 1px solid #ddd;\n}\n\n.edit-input {\n  flex: 1;\n  padding: 8px 12px;\n  border: 2px solid #3498db;\n  border-radius: 5px;\n  font-size: 0.9em;\n  outline: none;\n}\n\n.edit-input:focus {\n  border-color: #2980b9;\n  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.15);\n}\n\n.save-btn {\n  padding: 8px 14px;\n  background: #27ae60;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 0.85em;\n  white-space: nowrap;\n}\n\n.save-btn:hover:not(:disabled) {\n  background: #219a52;\n}\n\n.save-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.cancel-btn {\n  padding: 8px 10px;\n  background: #ecf0f1;\n  color: #7f8c8d;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 0.9em;\n}\n\n.secondary-btn {\n  margin-top: 10px;\n  padding: 8px 14px;\n  border-radius: 6px;\n  border: 1px solid #2980b9;\n  background: #fff;\n  color: #2980b9;\n  cursor: pointer;\n  font-size: 0.9em;\n}\n\n.secondary-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.cancel-btn:hover {\n  background: #ddd;\n}\n\n.fix-btn {\n  padding: 4px 10px;\n  background: #3498db;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.8em;\n  margin-left: auto;\n}\n\n.fix-btn:hover {\n  background: #2980b9;\n}\n\n.complete-btn {\n  padding: 4px 10px;\n  background: #27ae60;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.8em;\n  margin-left: auto;\n}\n\n.complete-btn:hover {\n  background: #219a52;\n}\n\n.task-create-form {\n  flex-wrap: wrap;\n}\n\n.priority-select {\n  padding: 8px;\n  border: 2px solid #ddd;\n  border-radius: 5px;\n  font-size: 0.85em;\n  background: white;\n}\n\n.date-input {\n  padding: 7px;\n  border: 2px solid #ddd;\n  border-radius: 5px;\n  font-size: 0.85em;\n}\n\n.section-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 2px solid #3498db;\n  padding-bottom: 10px;\n  margin-bottom: 15px;\n}\n\n.section-header-row h2 {\n  margin: 0;\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.scan-btn {\n  padding: 6px 14px;\n  background: #3498db;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 0.85em;\n  white-space: nowrap;\n}\n\n.scan-btn:hover:not(:disabled) {\n  background: #2980b9;\n}\n\n.scan-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
